import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentforlocalpartyinpune() {



  const cardData =
  {
    keyword: 'Bus on Rent for Local Party in Pune',
    heading: 'Sanavi Travels: Bus on Rent for Local Party in Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus on Rent for Local Party in Pune, providing safe, comfortable, and convenient transportation for family gatherings, friends’ outings, corporate parties, and social events within Pune city. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures spacious seating, clean interiors, and smooth rides for a hassle-free travel experience. With professional drivers, flexible hourly and full-day rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, making your local party or event travel safe, comfortable, and memorable. Choose Sanavi Travels for trusted bus rental services for local parties in Pune, delivering convenience, comfort, and reliable transportation for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,




"services": [
  {
    "name": "Bus on Rent for Local Party in Pune",
    "description": "Bus on Rent for Local Party in Pune provides spacious and comfortable buses for local party events."
  },
  {
    "name": "Party Bus Hire Pune",
    "description": "Party Bus Hire Pune offers fully-equipped buses for celebrations, birthdays, and social gatherings in Pune."
  },
  {
    "name": "AC Party Bus Pune",
    "description": "AC Party Bus Pune ensures a cool and comfortable ride with air-conditioned buses for party travel."
  },
  {
    "name": "Luxury Party Bus Pune",
    "description": "Luxury Party Bus Pune delivers premium buses with advanced comfort and entertainment features for parties."
  },
  {
    "name": "Birthday Party Bus Pune",
    "description": "Birthday Party Bus Pune provides specialized buses for birthday celebrations with fun and safe travel."
  },
  {
    "name": "Corporate Party Bus Pune",
    "description": "Corporate Party Bus Pune offers organized buses for company events, team outings, and corporate celebrations."
  },
  {
    "name": "Affordable Party Bus Pune",
    "description": "Affordable Party Bus Pune delivers budget-friendly buses for parties without compromising comfort or safety."
  },
  {
    "name": "Chauffeur Driven Party Bus",
    "description": "Chauffeur Driven Party Bus ensures stress-free travel with professional drivers handling routes and timing."
  },
  {
    "name": "Group Party Travel Bus Pune",
    "description": "Group Party Travel Bus Pune specializes in transporting groups safely and comfortably for party events."
  },
  {
    "name": "Best Party Bus Service Pune",
    "description": "Best Party Bus Service Pune provides top-quality party buses with reliable service and well-maintained vehicles."
  },
  {
    "name": "Pune Party Bus Booking",
    "description": "Pune Party Bus Booking allows easy reservations for party buses with flexible pickup and drop options."
  },
  {
    "name": "Night Party Bus Pune",
    "description": "Night Party Bus Pune offers buses for evening and late-night party travel with safety and comfort."
  },
  {
    "name": "Event Party Bus Pune",
    "description": "Event Party Bus Pune provides organized buses for weddings, events, and celebrations with professional chauffeurs."
  },
  {
    "name": "Friends Party Bus Pune",
    "description": "Friends Party Bus Pune offers fun and comfortable buses for friends’ gatherings and outings."
  },
  {
    "name": "Local Party Bus Pune",
    "description": "Local Party Bus Pune delivers convenient bus services for parties and events within Pune city."
  }
],
"tableData": [
  ["Bus on Rent for Local Party in Pune", "Party Bus Hire Pune"],
  ["AC Party Bus Pune", "Luxury Party Bus Pune"],
  ["Birthday Party Bus Pune", "Corporate Party Bus Pune"],
  ["Affordable Party Bus Pune", "Chauffeur Driven Party Bus"],
  ["Group Party Travel Bus Pune", "Best Party Bus Service Pune"],
  ["Pune Party Bus Booking", "Night Party Bus Pune"],
  ["Event Party Bus Pune", "Friends Party Bus Pune"],
  ["Local Party Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus on Rent for Local Party in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable buses on rent in Pune, perfect for local parties, family outings, friends’ gatherings, and corporate events."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced buses that provide a smooth and enjoyable ride for your local party in Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune routes, ensuring safe and timely travel for your event."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Pune, inclusive of fuel, driver allowances, and other charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to assist with bookings, route planning, and any last-minute changes for your local party bus."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized bus rental packages to suit your local party requirements in Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Buses",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for local party bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide buses on rent for local parties in Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rentals for local parties, gatherings, and events in Pune.'
  },
  {
    question: 'How can I book a bus for a local party in Pune?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for local party rentals?',
    answer: 'Sanavi Travels provides air-conditioned, well-maintained buses suitable for group outings and events.'
  },
  {
    question: 'Are drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with all local Pune routes.'
  },
  {
    question: 'Can I book a bus for a few hours only?',
    answer: 'Absolutely. We offer hourly, half-day, full-day, and custom rental packages to meet your needs.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support is available throughout your bus rental.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for local party bus rentals?',
    answer: 'Yes, we ensure on-time pickups and reliable service for all local party bus bookings in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshpande',
    feedback: 'Booked a bus for a local party in Pune. Spacious, comfortable, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Richa Patil',
    feedback: 'Excellent service for our Pune local party bus rental. Smooth ride and great customer support.',
    rating: 5
  }
];






























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent for Local Party in Pune - Sanavi Travels",
  "description": "Book buses for local parties in Pune with Sanavi Travels. AC and luxury party buses for birthdays, corporate events, night parties, group travel, friends' gatherings, and chauffeur-driven party trips.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Bus on Rent for Local Party in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses in Pune for local parties with Sanavi Travels. Ideal for birthdays, corporate events, night parties, friends' gatherings, group travel, and safe chauffeur-driven party trips."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/172.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentforlocalpartyinpune;